module.exports = __webpack_public_path__ + "arrow_01@2x.png?491cd67a9c0e9b138aab723244e329e7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow_01@2x.png
// module id = 160
// module chunks = 0